<template>
  <div>
    <div class="w100 hx clearfix" id="fa">
      <div class="title">
        <slot></slot>
      </div>
      <div class="content">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div
            :style="{ background: 'url(' + require('@/assets/'+ item['img']) + ') no-repeat center center'}"
          ></div>
          <p class="subt" v-if="!item['title']===false">{{item['title']}}</p>
          <!-- <p v-html="item.context">{{item}}</p> -->
          <div>
            <p class v-for="(ite, ind) in item['context']" :key="ind">{{ite}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'suitCase',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
#fa {
  padding-top: 92px;
  background: white;
}
.item div {
  width: 200px;
  height: 155px;
}
#fa .content .item {
  margin: 0;
}
#fa .content {
  width: 1040px;
  padding: 80px 0 0 0;
}
#fa .content p {
  line-height: 1px;
}
.content .subt {
  height: 21px;
  font-size: 22px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 25px;
}
.hx {
  background: white;
  padding-top: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/common/TechnicalHighlights.vue